import { jsx as _jsx } from "react/jsx-runtime";
import { Center, Image, Skeleton, } from '@chakra-ui/react';
import { STANDARD_IMAGE_ASPECT_RATIO } from '@client/constants';
import { useMinDuration } from '@client/hooks/useMinDuration';
import { useEffect, useState } from 'react';
import { FaRegImage } from 'react-icons/fa6';
var ImageStatus;
(function (ImageStatus) {
    ImageStatus[ImageStatus["LOADING"] = 0] = "LOADING";
    ImageStatus[ImageStatus["LOADED"] = 1] = "LOADED";
    ImageStatus[ImageStatus["ERROR"] = 2] = "ERROR";
})(ImageStatus || (ImageStatus = {}));
export const AppImage = ({ aspectRatio = STANDARD_IMAGE_ASPECT_RATIO, fallbackSrc, ...props }) => {
    const [status, setStatus] = useState(ImageStatus.LOADING);
    const [url, setUrl] = useState(props.imageProps?.src);
    const showSkeleton = useMinDuration(status === ImageStatus.LOADING);
    useEffect(() => {
        setUrl(props.imageProps?.src);
    }, [props.imageProps?.src]);
    if (status === ImageStatus.ERROR && !showSkeleton) {
        return (_jsx(Center, { aspectRatio: aspectRatio, bg: "gray.100", color: "fg.muted", ...props.containerProps, children: _jsx(FaRegImage, { size: "20%" }) }));
    }
    return (_jsx(Skeleton, { loading: showSkeleton, aspectRatio: aspectRatio, borderRadius: 0, ...props.containerProps, children: _jsx(Image, { width: "100%", objectFit: "cover", aspectRatio: aspectRatio, ...props.imageProps, src: url, onLoad: (e) => {
                setStatus(ImageStatus.LOADED);
                props.imageProps?.onLoad?.(e);
            }, onError: (e) => {
                if (fallbackSrc) {
                    setUrl(fallbackSrc);
                    return;
                }
                setStatus(ImageStatus.ERROR);
                props.imageProps?.onError?.(e);
            } }) }));
};
